import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    listOoraPayments,  
} from "../../Redux/Actions/ooraAction";
import { columnsOoraPaymentList } from "../../Global Functions/columnsAntd";  
import TableComponent from "../../Global Functions/tableComponentsCp";
import DateRangePopup from "../../Utils/dateFilterPopup";
import toast from "react-hot-toast";

const ListOoraPayments = () => {
    const dispatch = useDispatch();
    const [searchQuery, setSearchQuery] = useState("");
    const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
    const [dateRange, setDateRange] = useState({ start: null, end: null });
    const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
    });

    const { admin } = useSelector((state) => state.admin || {});

    const fetchDetails = useCallback(
        (showLoader = true) => {
            const payload = {
                page: pagination.current,
                limit: pagination.pageSize,
                filter: debouncedSearch,
                is_deleted: false,  
                ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
                ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
            };
            return dispatch(listOoraPayments(payload)).catch(() => {
                if (showLoader) {
                    toast.error("Failed to fetch payments list");
                }
            });
        },
        [dispatch, pagination.current, pagination.pageSize, debouncedSearch, dateRange]
    );

    const ooraPlanState = useSelector((state) => state.oora || {});
    const payments = useMemo(() => {
        return ooraPlanState.payments?.data || [];  
    }, [ooraPlanState.payments]);
    const paymentTotal = useMemo(() => {
        return ooraPlanState.payments?.total || 0;  
    }, [ooraPlanState.payments]);
    const { loading } = ooraPlanState;

    useEffect(() => {
        fetchDetails(true);
    }, [fetchDetails]);

    useEffect(() => {
        setPagination((prev) => ({ ...prev, total: paymentTotal }));
    }, [paymentTotal]);

    const handleDateRangeApply = (start, end) => {
        if (start === null && end === null) {
            setDateRange({ start: null, end: null });
        } else {
            setDateRange({ start, end });
        }
        setIsDatePopupVisible(false);
        setPagination((prev) => ({ ...prev, current: 1 }));
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchQuery);
        }, 500);
        return () => clearTimeout(handler);
    }, [searchQuery]);

    const handleTableChange = (pagination) => {
        setPagination(pagination);
        fetchDetails(false);
    };

    return (
        <>
            <TableComponent
                pagination={pagination}
                setState={setSearchQuery}
                dataSource={payments}  
                onChange={handleTableChange}
                h3heading="Oora Payments List"  
                onCalendarClick={() => setIsDatePopupVisible(true)}
                columns={columnsOoraPaymentList(pagination.current, pagination.pageSize)}  
                loading={loading}
            />

            <DateRangePopup
                visible={isDatePopupVisible}
                initialStart={dateRange.start}
                initialEnd={dateRange.end}
                onCancel={() => setIsDatePopupVisible(false)}
                onOk={handleDateRangeApply}
            />
        </>
    );
};

export default ListOoraPayments;
